/* eslint-disable import/prefer-default-export */
export const FeatureConfig = {
  enableAddTask: false,
  enableZoneSelection: true,
  serviceBeatLimit: 1000,
};
